<div class="padding">
<div class="carousel carousel-showmanymoveone slide" id="carousel-tilenav" data-interval="false">
  <div class="carousel-inner">
    <div class="panel panel-default">
      @if(isLoadingResults){
        <div class="example-loading-shade">
          @if(isLoadingResults){
            <mat-spinner diameter="30"></mat-spinner>
          }
        </div>
      }
      <div class="panel-heading">
        <p class="panel-title">
          FINRA Rejects and Repairs</p>
      </div>
      <div>
        <div>
          <div style="display: block">
            <div class="chart-container">
              <canvas baseChart
                style="display: block;height: 100%;padding: 19px;width: 100%;" 
                [data]="chartData"  
                [type]="'bar'"  
                [options]="barChartOptions"          
                >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <a class="align-bottom left carousel-control" matTooltip="Prev" [matTooltipShowDelay]="1000" (click)="clickLeft()" data-slide="prev"><i
      class="glyphicon glyphicon-chevron-left"></i></a>
  <a class="align-bottom right carousel-control" matTooltip="Next" [matTooltipShowDelay]="1000" (click)="clickRight()" data-slide="next"><i
      class="glyphicon glyphicon-chevron-right"></i></a>
</div>
</div>